import React from 'react';
import './StatusBadge.scss';
import {ChannelType} from "../model";

interface StatusBadgeProps {
  badgeTitle: string;
}

const Badge: React.FC<StatusBadgeProps> = ({ badgeTitle }) => {
  let className = "status-badge default";
  let label = "Unknown";

  switch (badgeTitle) {
    case 'AWAITING_FILE_UPLOAD':
    case 'INACTIVE':
      className = 'status-badge awaiting';
      label = "Awaiting File Upload";
      break;
    case 'READY':
    case 'ACTIVE':
      className = 'status-badge ready';
      label = "Ready";
      break;
    case 'DISCONNECTED':
      className = 'status-badge orange';
      label = "Not connected";
      break;
    case 'CONNECTED':
      className = 'status-badge green';
      label = "Connected";
      break;
    case ChannelType.TELEGRAM:
      className = 'status-badge green';
      label = badgeTitle;
      break;
    case ChannelType.WEBHOOK:
      className = 'status-badge blue';
      label = badgeTitle;
      break;
    default:
      className = 'status-badge green';
      label = badgeTitle;
      break;
    // You can add more cases here
  }

  return <span className={className}>{label}</span>;
};

export default Badge;
